
import NavLink from "./NavLink"
import stubDirectives from "../mixins/stubDirectives"
import { PROJECTS } from "../config/projectRouting"

export default {
  inject: {
    currentProject: {
      default: PROJECTS.Website
    }
  },
  components: {
    NavLink
  },
  mixins: [stubDirectives],
  props: {
    supportLinks: {
      type: Object,
      default: () => {
        return {}
      }
    },
    companyLinks: {
      type: Object,
      default: () => {
        return {}
      }
    },
    socialLinks: {
      type: Object,
      default: () => {
        return {}
      }
    },
    copyright: {
      type: String,
      default: ""
    },
    companyInfo: {
      type: String,
      default: ""
    },
    trackingClickGroup: {
      type: [Array, Object],
      default: null
    }
  },
  computed: {
    isV2() {
      return process.env.VUE_APP_NEW_BRANDING === "true"
    },
    footerContainerClasses() {
      return process.env.VUE_APP_NEW_BRANDING === "true"
        ? "footer-container-v2 is-size-7"
        : "footer-container pt-8 pb-9 px-4 is-size-7"
    },
    companyLinksFiltered() {
      let filteredList = []
      if (this.companyLinks && this.companyLinks.navLinks) {
        this.companyLinks.navLinks.map(item => {
          if (
            !item.hideForSites ||
            !item.hideForSites.includes(this.currentProject)
          ) {
            filteredList.push(item)
          }
        })
      }
      return filteredList
    }
  }
}
